module.exports = __webpack_public_path__ + "nc_static/media/cards.2ea2eecd.svg";